module.exports = __webpack_public_path__ + "static/img/advert_2.3f65528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CopierSelfprinting/advert_2.png
// module id = m0/z
// module chunks = 10